import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfig);

export const firebaseApp = app;
export const fAuth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

/** Same region as deployed callables (see functions/sendMail.js). */
export const FUNCTIONS_REGION = "us-central1";
export const fFunctions = getFunctions(app, FUNCTIONS_REGION);

// Point the web app at the local Functions emulator (must match firebase.json port).
if (
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === "true"
) {
  const emHost = process.env.REACT_APP_EMULATOR_HOST || "127.0.0.1";
  const emPort = Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || 5001);
  connectFunctionsEmulator(fFunctions, emHost, emPort);
}
